import { TribuNotification } from '@tribuu-api';

export namespace NotificationActions {
  export class FetchAll {
    static readonly type = '[Notifications] Fetch All';
  }

  export class Add {
    static readonly type = '[Notifications] Add';
    constructor(public payload: TribuNotification) {}
  }

  export class Remove {
    static readonly type = '[Notifications] Remove';
    constructor(public uid: string) {}
  }

  export class ReadAll {
    static readonly type = '[Notifications] Read All';
  }

  export class Toggle {
    static readonly type = '[Notifications] Toggle';
    constructor(public value?: boolean) {}
  }

  export class ExecuteActionsOnReceive {
    static readonly type = '[Notifications] Execute Actions';
    constructor(public actions: string[]) {}
  }

  export class Reset {
    static readonly type = '[Notifications] Reset';
  }
}
